import { render } from "./EnergyTransitionResponsibility.vue?vue&type=template&id=0921f4be&ts=true"
import script from "./EnergyTransitionResponsibility.vue?vue&type=script&lang=ts"
export * from "./EnergyTransitionResponsibility.vue?vue&type=script&lang=ts"

import "./EnergyTransitionResponsibility.vue?vue&type=style&index=0&id=0921f4be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__